import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import { guestVatSupportLink, hostVatSupportLink } from "../data/supportLinks";

import { useTaxDetails } from "./TaxDetailsProvider";

/**
 * Renders the Tax Details explainer copy and its support article link.
 */
const TaxDetailsDescription = () => {
  const { isHost } = useTaxDetails();

  return (
    <Text>
      {isHost ? (
        <FormattedMessage
          id="hosting.taxes.tax_details_copy"
          defaultMessage="Adding your tax registration may change how taxes are charged on your bookings. It’s the host’s responsibility to keep all tax details up to date."
        />
      ) : (
        <FormattedMessage
          id="hosting.guest_taxes.tax_details_copy"
          defaultMessage="Adding your tax registration may change how taxes are charged on your bookings. It’s the guest’s responsibility to keep all tax details up to date."
        />
      )}{" "}
      <a
        className="tw-underline tw-text-gray-900 hover:tw-underline hover:tw-text-gray-900"
        href={isHost ? hostVatSupportLink : guestVatSupportLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id="hosting.taxes.learn_more_link"
          defaultMessage="Learn more"
        />
      </a>
    </Text>
  );
};

export { TaxDetailsDescription };
